import type { CarouselItem, Collection } from "@/types/media";

export const carouselItems: CarouselItem[] = [
  {
    id: "m-001",
    type: "movie",
    title: "星际远征",
    tagline: "穿越虫洞，为人类寻找新的家园",
    genres: ["科幻", "冒险"],
    rating: 9.1,
    year: 2024,
    backdrop:
      "https://readdy.ai/api/search-image?query=epic%20cinematic%20sci-fi%20scene%2C%20astronaut%20walking%20toward%20a%20colossal%20glowing%20ringed%20planet%20in%20deep%20dark%20blue%20space%2C%20volumetric%20light%2C%20dramatic%20scale%2C%20wide%20shot%2C%20high%20detail%20key%20art&width=1600&height=900&seq=hero-backdrop-001&orientation=landscape",
    description: "当地球资源濒临枯竭，一支探险队穿越虫洞，前往遥远星系寻找人类新的家园。",
  },
  {
    id: "t-001",
    type: "tv",
    title: "苍穹之巅",
    tagline: "悬浮都市之下，真相正在崩塌",
    genres: ["科幻", "悬疑"],
    rating: 8.9,
    year: 2024,
    backdrop:
      "https://readdy.ai/api/search-image?query=futuristic%20floating%20metropolis%20above%20storm%20clouds%20at%20night%2C%20deep%20navy%20and%20cyan%20glow%2C%20epic%20wide%20cinematic%20scene%2C%20dramatic%20scale%2C%20high%20detail%20key%20art&width=1600&height=900&seq=hero-backdrop-002&orientation=landscape",
    description: "一名普通工程师意外掌握了足以颠覆秩序的机密，必须在追杀中寻找真相。",
  },
  {
    id: "m-006",
    type: "movie",
    title: "时间褶皱",
    tagline: "时间不是线，而是一道可以被折叠的褶皱",
    genres: ["科幻", "悬疑"],
    rating: 8.8,
    year: 2024,
    backdrop:
      "https://readdy.ai/api/search-image?query=surreal%20infinite%20mirror%20corridor%20made%20of%20fractured%20glass%2C%20deep%20blue%20and%20silver%20tone%2C%20moody%20architectural%20wide%20cinematic%20scene%2C%20high%20detail%20key%20art&width=1600&height=900&seq=hero-backdrop-003&orientation=landscape",
    description: "一位天体物理学家发现时间可以被折叠，为了挽回一场意外不断穿梭时间线。",
  },
  {
    id: "m-002",
    type: "movie",
    title: "无声之城",
    tagline: "城市的每一声回响，都藏着秘密",
    genres: ["悬疑", "犯罪"],
    rating: 8.6,
    year: 2023,
    backdrop:
      "https://readdy.ai/api/search-image?query=rainy%20empty%20city%20street%20at%20night%20with%20neon%20reflections%20on%20wet%20asphalt%2C%20lone%20silhouette%20figure%2C%20deep%20blue%20and%20charcoal%20cinematic%20wide%20scene%2C%20high%20detail%20key%20art&width=1600&height=900&seq=hero-backdrop-004&orientation=landscape",
    description: "一桩离奇的失踪案打破了城市的平静，刑警逐渐发现自己也被卷入了这场博弈。",
  },
];

export const quickCategories = [
  {
    id: "movie",
    title: "电影频道",
    subtitle: "最新大片 · 经典佳作",
    description: "收录最新上映与影史经典，支持类型、地区、年份多维筛选。",
    cover:
      "https://readdy.ai/api/search-image?query=cinema%20hall%20with%20rows%20of%20seats%20glowing%20in%20deep%20blue%20light%2C%20large%20screen%20glow%2C%20dusty%20cinematic%20atmosphere%2C%20moody%20editorial%20photography%2C%20high%20detail&width=800&height=600&seq=category-movie-cover&orientation=landscape",
    count: 16,
  },
  {
    id: "tv",
    title: "电视剧频道",
    subtitle: "热播剧集 · 同步追更",
    description: "涵盖都市、悬疑、古装、科幻等热门剧集，实时显示更新进度。",
    cover:
      "https://readdy.ai/api/search-image?query=cozy%20living%20room%20at%20night%20with%20a%20large%20tv%20glowing%20deep%20blue%2C%20ambient%20light%20and%20soft%20shadows%2C%20cinematic%20moody%20photography%2C%20high%20detail&width=800&height=600&seq=category-tv-cover&orientation=landscape",
    count: 12,
  },
];

export const collections: Collection[] = [
  {
    id: "classic",
    title: "经典电影推荐",
    subtitle: "值得反复回味的影史佳作",
    cover:
      "https://readdy.ai/api/search-image?query=vintage%20film%20reels%20and%20old%20projector%20in%20a%20dim%20archival%20room%2C%20deep%20blue%20and%20amber%20light%2C%20nostalgic%20cinematic%20mood%2C%20high%20detail&width=800&height=600&seq=collection-classic-cover&orientation=landscape",
    count: 6,
    items: [
      { id: "m-015", type: "movie", title: "老街故事", poster: "https://readdy.ai/api/search-image?query=arthouse%20drama%20movie%20poster%2C%20quiet%20old%20chinese%20street%20with%20bare%20trees%20and%20small%20shops%20at%20dusk%2C%20muted%20blue%20grey%20and%20warm%20window%20light%2C%20melancholic%20cinematic%20mood%2C%20high%20detail&width=600&height=900&seq=movie-poster-015&orientation=portrait" },
      { id: "m-005", type: "movie", title: "江湖夜雨", poster: "https://readdy.ai/api/search-image?query=wuxia%20martial%20arts%20movie%20poster%2C%20lone%20swordsman%20in%20flowing%20robe%20standing%20on%20misty%20ancient%20rooftop%2C%20deep%20indigo%20night%20with%20falling%20rain%2C%20moonlit%20atmosphere%2C%20ink%20painting%20aesthetic%2C%20high%20detail%20key%20art&width=600&height=900&seq=movie-poster-005&orientation=portrait" },
      { id: "m-012", type: "movie", title: "雾都疑云", poster: "https://readdy.ai/api/search-image?query=british%20mystery%20thriller%20movie%20poster%2C%20lone%20detective%20in%20trench%20coat%20walking%20through%20foggy%20london%20alley%20with%20gas%20lamps%2C%20deep%20slate%20blue%20and%20amber%20palette%2C%20atmospheric%20cinematic%20mood%2C%20high%20detail&width=600&height=900&seq=movie-poster-012&orientation=portrait" },
      { id: "m-009", type: "movie", title: "长安幻夜", poster: "https://readdy.ai/api/search-image?query=ancient%20chinese%20fantasy%20movie%20poster%2C%20ornate%20tang%20dynasty%20palace%20at%20night%20with%20floating%20lanterns%20and%20mysterious%20fog%2C%20deep%20blue%20and%20crimson%20accents%2C%20epic%20cinematic%20mood%2C%20intricate%20detail%2C%20high%20detail%20key%20art&width=600&height=900&seq=movie-poster-009&orientation=portrait" },
    ],
  },
  {
    id: "binge",
    title: "影迷必看剧集",
    subtitle: "一口气刷完的口碑神剧",
    cover:
      "https://readdy.ai/api/search-image?query=stack%20of%20blank%20dark%20tv%20screens%20glowing%20deep%20blue%20in%20a%20dim%20minimal%20room%2C%20cinematic%20moody%20lighting%2C%20high%20detail&width=800&height=600&seq=collection-binge-cover&orientation=landscape",
    count: 6,
    items: [
      { id: "t-002", type: "tv", title: "长安十二时辰", poster: "https://readdy.ai/api/search-image?query=ancient%20chinese%20historical%20mystery%20tv%20poster%2C%20tang%20dynasty%20city%20gate%20at%20dawn%20with%20lanterns%20and%20fog%2C%20deep%20blue%20and%20crimson%20accent%20palette%2C%20epic%20cinematic%20vertical%20key%20art%2C%20high%20detail&width=600&height=900&seq=tv-poster-002&orientation=portrait" },
      { id: "t-004", type: "tv", title: "罪案档案", poster: "https://readdy.ai/api/search-image?query=crime%20thriller%20tv%20series%20poster%2C%20detective%20pinning%20photos%20on%20a%20dim%20investigation%20board%2C%20deep%20blue%20and%20grey%20palette%2C%20tense%20noir%20cinematic%20mood%2C%20high%20detail&width=600&height=900&seq=tv-poster-004&orientation=portrait" },
      { id: "t-005", type: "tv", title: "王朝风云", poster: "https://readdy.ai/api/search-image?query=royal%20historical%20drama%20tv%20poster%2C%20majestic%20throne%20room%20with%20a%20crown%20on%20velvet%20cushion%2C%20deep%20blue%20and%20gold%20palette%2C%20regal%20cinematic%20mood%2C%20high%20detail&width=600&height=900&seq=tv-poster-005&orientation=portrait" },
      { id: "t-011", type: "tv", title: "山河故人", poster: "https://readdy.ai/api/search-image?query=epic%20period%20drama%20tv%20poster%2C%20old%20chinese%20courtyard%20house%20with%20red%20lanterns%20under%20dusk%20sky%2C%20muted%20blue%20and%20amber%20palette%2C%20nostalgic%20cinematic%20mood%2C%20high%20detail&width=600&height=900&seq=tv-poster-011&orientation=portrait" },
    ],
  },
  {
    id: "scifi",
    title: "科幻宇宙特辑",
    subtitle: "想象力没有边界",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20nebula%20galaxy%20with%20geometric%20planet%20rings%2C%20deep%20blue%20and%20cyan%20glow%2C%20sci-fi%20concept%20wide%20scene%2C%20high%20detail&width=800&height=600&seq=collection-scifi-cover&orientation=landscape",
    count: 5,
    items: [
      { id: "m-001", type: "movie", title: "星际远征", poster: "https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20movie%20poster%2C%20lone%20astronaut%20before%20a%20giant%20glowing%20ringed%20planet%2C%20deep%20navy%20and%20black%20gradient%20background%2C%20volumetric%20light%20rays%2C%20dramatic%20moody%20atmosphere%2C%20high%20detail%20editorial%20key%20art&width=600&height=900&seq=movie-poster-001&orientation=portrait" },
      { id: "m-004", type: "movie", title: "深海迷航", poster: "https://readdy.ai/api/search-image?query=underwater%20sci-fi%20horror%20movie%20poster%2C%20submarine%20descending%20into%20abyssal%20trench%20with%20eerie%20blue%20glow%2C%20dark%20teal%20and%20black%20gradient%2C%20bioluminescent%20particles%2C%20tense%20cinematic%20atmosphere%2C%20high%20detail&width=600&height=900&seq=movie-poster-004&orientation=portrait" },
      { id: "t-010", type: "tv", title: "星际学院", poster: "https://readdy.ai/api/search-image?query=sci-fi%20academy%20tv%20poster%2C%20young%20cadets%20in%20uniform%20before%20a%20giant%20spaceship%20hangar%2C%20deep%20blue%20and%20cyan%20lighting%2C%20adventurous%20cinematic%20mood%2C%20high%20detail&width=600&height=900&seq=tv-poster-010&orientation=portrait" },
      { id: "t-008", type: "tv", title: "迷雾小镇", poster: "https://readdy.ai/api/search-image?query=mysterious%20small%20town%20thriller%20tv%20poster%2C%20abandoned%20houses%20swallowed%20by%20dense%20fog%2C%20eerie%20deep%20blue%20and%20grey%20palette%2C%20haunting%20cinematic%20mood%2C%20high%20detail&width=600&height=900&seq=tv-poster-008&orientation=portrait" },
    ],
  },
];